import moment from 'moment';
import { map, startCase } from 'lodash';
// Add global formatMoney filter
const moneyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});

export function formatMoney(cents) {
    if (cents) {
        const dollarAmount = cents / 100;
        return moneyFormatter.format(dollarAmount);
    }
    return '$0';
}
export function moneyFilter(value) {
    return moneyFormatter.format(value);
}
export function momentWrapper(input, format) {
    const tmpDate = moment(input);
    if (tmpDate.isValid) {
        return tmpDate.format(format);
    }
    // fallback if moment can't parse
    return input;
}
export function dateFilter(value) {
    const offset = moment(new Date()).utcOffset();
    const dateObj = moment.utc(value);
    if (dateObj.isBefore('1880-01-01')) {
        return 'N/A';
    }
    return dateObj.utcOffset(offset).format('l');
}
export function localTime(val) {
    if (!val) return '';

    return moment.utc(val).local().format('MMM Do [at] h:mm A');
}
export function timeFilter(value) {
    const offset = moment(new Date()).utcOffset();
    return moment.utc(value).utcOffset(offset).format('LT');
}
export function durationTimeStamp(val) {
    var minutes = Math.floor(val / 60);
    var seconds = val - minutes * 60;

    function str_pad_left(string, pad, length) {
        return (new Array(length + 1).join(pad) + string).slice(-length);
    }
    const finalTime = minutes + ':' + str_pad_left(seconds, '0', 2);
    return finalTime;
}
export function formatTimeStamp(seconds) {
    const duration = moment.duration(seconds, 'seconds');
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(secs).padStart(2, '0');
    if (hours > 0) {
        return `${hours}:${formattedMinutes}:${formattedSeconds}`;
    }
    return `${formattedMinutes}:${formattedSeconds}`;
}
export function initials(text) {
    const words = text?.split(' ').filter((_word, index, arr) => index === 0 || index === arr.length - 1);
    return map(words, w => w.charAt(0)).join('');
}
export function firstName(text) {
    const words = text?.split(' ');

    if (words.length > 0) return words[0];

    return null;
}
export function nextDay(val) {
    let next = moment(val).add(1, 'd').format('l');
    return next;
}
export function dateFormat(value) {
    return moment(value).format('l');
}
export function labelFilter(value) {
    if (value === 'Regional Manager') {
        return 'RM';
    } else {
        return value;
    }
}
export function toCurrency(value) {
    if (value) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return formatter.format(value / 100);
    } else {
        return '$0';
    }
}
export function truncate(text, length, suffix) {
    if (text && text.length > length) {
        return text.substring(0, length) + suffix;
    } else {
        return text;
    }
}

export function formatFileSize(fileSizeInBytes) {
    const kilobyte = 1024;
    const megabyte = kilobyte * 1024;
    const gigabyte = megabyte * 1024;

    if (fileSizeInBytes >= gigabyte) {
        return (fileSizeInBytes / gigabyte).toFixed(2) + ' GB';
    } else if (fileSizeInBytes >= megabyte) {
        return (fileSizeInBytes / megabyte).toFixed(2) + ' MB';
    } else if (fileSizeInBytes >= kilobyte) {
        return (fileSizeInBytes / kilobyte).toFixed(2) + ' KB';
    } else {
        return fileSizeInBytes + ' bytes';
    }
}
export function initGlobalFilters(app) {
    app.config.globalProperties.$filters = {
        formatMoney,
        moment: function (input, format) {
            const tmpDate = moment(input);
            if (tmpDate.isValid) {
                return tmpDate.format(format);
            }
            // fallback if moment can't parse
            return input;
        },
        moneyFilter,
        momentWrapper,
        dateFilter,
        localTime,
        timeFilter,
        durationTimeStamp,
        formatTimeStamp,
        initials,
        firstName,
        nextDay,
        dateFormat,
        labelFilter,
        toCurrency,
        truncate,
        startCase,
        formatFileSize,
    };
}